{
  "familyId": "SWW-VT-DUBBEL",
  "questions": [
    {
      "id": "SWW-VT-DUBBEL-001",
      "familyId": "SWW-VT-DUBBEL",
      "module": "SpellingWW",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "verleden_tijd",
      "subSkill": "vt_dubbel_dt",
      "questionType": "multiple_choice",
      "question": "De leerlingen ... hard voor de toets. (werken, verleden tijd meervoud)",
      "context": null,
      "options": ["werkten", "werkte", "werktten", "gewerkt"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{ "type": "rule", "data": { "title": "Dubbele Letters", "content": "Als de stam al eindigt op -t, krijg je dubbele t: werk + te = werkte, werk + ten = werkten (niet werktten!).", "icon": "lightbulb" }, "showWhen": "wrong" }],
      "conceptId": "complex_verb_forms_plural_past",
      "variantIndex": 1,
      "citoDifficulty": 0.32,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "Regel: kofschip-regel met dubbele letters. Stap 1: De stam van 'werken' is 'werk'. Stap 2: De laatste letter 'k' zit in 't kofschip → dus -te(n). Stap 3: 'De leerlingen' is meervoud → werk + ten = werkten. Let op: NIET werktten (geen dubbele t bij meervoud). Checkstrategie: tel de letters — stam + ten = één t, niet twee.",
        "solutionSteps": ["Bepaal de stam: werken → werk", "Kofschip: 'k' zit in kofschip → -te(n)", "'De leerlingen' is meervoud → gebruik -ten", "werk + ten = werkten (niet werktten!)"],
        "distractorExplanations": {
          "0": "Correct! Kofschip-regel: 'k' in kofschip → werk + ten = werkten (meervoud).",
          "1": "Hier is enkelvoud gebruikt bij een meervoud onderwerp. 'Werkte' is enkelvoud (hij/zij werkte). 'De leerlingen' is meervoud, dus -ten: werkten. Misconceptie: enkelvoud en meervoud verwarren.",
          "2": "Hier is een extra t toegevoegd. 'Werktten' heeft een dubbele t te veel. De regel is: stam + ten = werkten (niet werk + tten). Misconceptie: denken dat de t van de stam en de t van -ten apart geschreven worden.",
          "3": "Hier is het voltooid deelwoord gebruikt zonder hulpwerkwoord. 'Gewerkt' hoort bij 'hebben gewerkt'. Hier is geen hulpwerkwoord, dus gewoon verleden tijd: werkten."
        }
      }
    },
    {
      "id": "SWW-VT-DUBBEL-002",
      "familyId": "SWW-VT-DUBBEL",
      "module": "SpellingWW",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "verleden_tijd",
      "subSkill": "vt_dubbel_dt",
      "questionType": "multiple_choice",
      "question": "Hij ... de hele avond met zijn vrienden. (praten, verleden tijd)",
      "context": null,
      "options": ["praatte", "praate", "pratte", "pratete"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{ "type": "rule", "data": { "title": "Dubbele t bij verleden tijd", "content": "De stam van 'praten' is 'praat' (eindigt op t). Kofschip: t zit in kofschip → -te. Stam + te = praat + te = praatte (dubbel t). Dat is correct!", "icon": "lightbulb" }, "showWhen": "wrong" }],
      "conceptId": "vt_double_t_praten",
      "variantIndex": 2,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.71,
      "feedback": {
        "explanationText": "Regel: dubbele medeklinker in verleden tijd. Stap 1: De stam van 'praten' is 'praat' (met lange a → dubbele a in open lettergreep wordt enkel, maar de stam is 'praat'). Stap 2: De laatste letter 't' zit in 't kofschip → -te. Stap 3: praat + te = praatte (dubbel t). Dit ziet er gek uit, maar het is correct! De ene t hoort bij de stam, de andere bij de uitgang.",
        "solutionSteps": ["Bepaal de stam: praten → praat", "Kofschip: 't' zit in kofschip → -te", "praat + te = praatte (dubbel t)", "Check: één t van de stam + één t van -te = twee t's"],
        "distractorExplanations": {
          "0": "Correct! De stam 'praat' eindigt op t, plus de uitgang -te: praat + te = praatte.",
          "1": "Hier ontbreekt een t. 'Praate' mist de t van de uitgang -te. De stam is 'praat' en de uitgang is -te: praat + te = praatte. Misconceptie: denken dat de t van de stam de uitgang vervangt.",
          "2": "Hier is de stam verkeerd geschreven. 'Pratte' heeft maar één a, maar de stam is 'praat' (met dubbele a). Onthoud: de stam verandert niet. Misconceptie: de stam inkorten.",
          "3": "Hier is -te dubbel toegevoegd. 'Pratete' heeft een extra lettergreep. De regel is simpel: stam + te = praatte. Misconceptie: de uitgang twee keer toevoegen."
        }
      }
    },
    {
      "id": "SWW-VT-DUBBEL-003",
      "familyId": "SWW-VT-DUBBEL",
      "module": "SpellingWW",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "verleden_tijd",
      "subSkill": "vt_dubbel_dt",
      "questionType": "multiple_choice",
      "question": "Zij ... op alle vragen. (antwoorden, verleden tijd enkelvoud)",
      "context": null,
      "options": ["antwoordde", "antwoorde", "antwoordte", "antwoordede"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{ "type": "rule", "data": { "title": "Dubbele d bij verleden tijd", "content": "De stam van 'antwoorden' is 'antwoord' (eindigt op d). D zit NIET in kofschip → -de. Stam + de = antwoord + de = antwoordde (dubbel d).", "icon": "lightbulb" }, "showWhen": "wrong" }],
      "conceptId": "vt_double_d_antwoorden",
      "variantIndex": 3,
      "citoDifficulty": 0.38,
      "citoDiscrimination": 0.70,
      "feedback": {
        "explanationText": "Regel: dubbele medeklinker in verleden tijd. Stap 1: De stam van 'antwoorden' is 'antwoord'. Stap 2: De laatste letter 'd' zit NIET in 't kofschip → -de. Stap 3: antwoord + de = antwoordde (dubbel d). De ene d hoort bij de stam, de andere bij de uitgang -de.",
        "solutionSteps": ["Bepaal de stam: antwoorden → antwoord", "Kofschip: 'd' zit NIET in kofschip → -de", "antwoord + de = antwoordde (dubbel d)", "Check: één d van de stam + één d van -de = twee d's"],
        "distractorExplanations": {
          "0": "Correct! De stam 'antwoord' eindigt op d, plus de uitgang -de: antwoord + de = antwoordde.",
          "1": "Hier ontbreekt een d. 'Antwoorde' mist de d van de uitgang -de. De stam is 'antwoord' en de uitgang is -de: antwoord + de = antwoordde. Misconceptie: denken dat de d van de stam de uitgang vervangt.",
          "2": "Hier is -te gebruikt in plaats van -de. Maar 'd' zit NIET in 't kofschip, dus de uitgang is -de (niet -te): antwoordde. Misconceptie: kofschip verkeerd toepassen.",
          "3": "Hier is -de dubbel toegevoegd. 'Antwoordede' heeft een extra lettergreep. De regel is simpel: stam + de = antwoordde. Misconceptie: de uitgang twee keer toevoegen."
        }
      }
    },
    {
      "id": "SWW-VT-DUBBEL-004",
      "familyId": "SWW-VT-DUBBEL",
      "module": "SpellingWW",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "verleden_tijd",
      "subSkill": "vt_dubbel_dt",
      "questionType": "multiple_choice",
      "question": "Welke zin is juist geschreven?",
      "context": null,
      "options": ["Ik zette de tas op tafel.", "Ik zete de tas op tafel.", "Ik zetde de tas op tafel.", "Ik zettede de tas op tafel."],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{ "type": "rule", "data": { "title": "Dubbele t bij verleden tijd", "content": "De stam van 'zetten' is 'zet' (eindigt op t). Kofschip: t zit in kofschip → -te. Stam + te = zet + te = zette (dubbel t).", "icon": "lightbulb" }, "showWhen": "wrong" }],
      "conceptId": "vt_double_t_zetten",
      "variantIndex": 4,
      "citoDifficulty": 0.36,
      "citoDiscrimination": 0.71,
      "feedback": {
        "explanationText": "Regel: dubbele medeklinker in verleden tijd. Stap 1: De stam van 'zetten' is 'zet'. Stap 2: De laatste letter 't' zit in 't kofschip → -te. Stap 3: zet + te = zette (dubbel t). Checkstrategie: de ene t hoort bij de stam, de andere bij de uitgang.",
        "solutionSteps": ["Bepaal de stam: zetten → zet", "Kofschip: 't' zit in kofschip → -te", "zet + te = zette (dubbel t)", "Check: stam-t + uitgang-t = twee t's"],
        "distractorExplanations": {
          "0": "Correct! De stam 'zet' eindigt op t, plus de uitgang -te: zet + te = zette.",
          "1": "Hier ontbreekt een t. 'Zete' mist de t van de uitgang. De stam is 'zet' en de uitgang is -te: zet + te = zette. Misconceptie: denken dat de stam-t de uitgang vervangt.",
          "2": "Hier is -de gebruikt in plaats van -te. Maar 't' zit WEL in 't kofschip, dus de uitgang is -te (niet -de): zette. Misconceptie: kofschip verkeerd toepassen.",
          "3": "Hier is de uitgang dubbel toegevoegd. 'Zettede' klopt niet. De regel is simpel: stam + te = zette. Misconceptie: de uitgang twee keer toevoegen."
        }
      }
    },
    {
      "id": "SWW-VT-DUBBEL-005",
      "familyId": "SWW-VT-DUBBEL",
      "module": "SpellingWW",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "verleden_tijd",
      "subSkill": "vt_dubbel_dt",
      "questionType": "fill_in",
      "question": "Vul in: 'Hij ... de kinderen uit het water.' (redden, verleden tijd enkelvoud) Typ het hele woord.",
      "context": null,
      "options": [],
      "correctAnswer": 0,
      "data": { "acceptedAnswers": ["redde"], "caseSensitive": false, "placeholder": "..." },
      "stimulusAids": [],
      "supportAids": [{ "type": "rule", "data": { "title": "Dubbele d bij verleden tijd", "content": "De stam van 'redden' is 'red' (eindigt op d). D zit NIET in kofschip → -de. Stam + de = red + de = redde (dubbel d).", "icon": "lightbulb" }, "showWhen": "wrong" }],
      "conceptId": "vt_double_d_fill",
      "variantIndex": 5,
      "citoDifficulty": 0.40,
      "citoDiscrimination": 0.69,
      "feedback": {
        "explanationText": "Regel: dubbele medeklinker in verleden tijd. Stap 1: De stam van 'redden' is 'red'. Stap 2: De laatste letter 'd' zit NIET in 't kofschip → -de. Stap 3: red + de = redde (dubbel d). De ene d hoort bij de stam, de andere bij de uitgang.",
        "solutionSteps": ["Bepaal de stam: redden → red", "Kofschip: 'd' zit NIET in kofschip → -de", "red + de = redde (dubbel d)"]
      }
    },
    {
      "id": "SWW-VT-DUBBEL-006",
      "familyId": "SWW-VT-DUBBEL",
      "module": "SpellingWW",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "verleden_tijd",
      "subSkill": "vt_dubbel_dt",
      "questionType": "error_spotting",
      "question": "Vind de werkwoordspellingfouten in deze tekst over dubbele letters in de verleden tijd.",
      "correctAnswer": null,
      "data": {
        "text": "De kok bakte een taart en reden snel naar de winkel. Daarna paktte hij de spullen in en stuurde een bericht.",
        "errors": [
          { "word": "reden", "correction": "reed", "startIndex": 32, "endIndex": 37, "explanation": "'Rijden' is een sterk werkwoord: hij reed (niet reden — dat is meervoud)." },
          { "word": "paktte", "correction": "pakte", "startIndex": 64, "endIndex": 70, "explanation": "Stam 'pak' + te = pakte. De k zit in kofschip → -te. Geen dubbele t nodig want de stam eindigt niet op t." }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        { "type": "verbTable", "showWhen": "wrong", "data": { "verb": "pakken", "forms": { "stam": "pak", "tt_ik": "pak", "tt_jij": "pakt", "tt_hij": "pakt", "vt_ik": "pakte", "vt_wij": "pakten", "vd": "gepakt" } } }
      ],
      "conceptId": "dubbel_error_spotting",
      "variantIndex": 6,
      "citoDifficulty": 0.42,
      "citoDiscrimination": 0.70,
      "feedback": {
        "explanationText": "Twee fouten: 1) 'reden' moet 'reed' zijn — rijden is een sterk werkwoord (hij reed, enkelvoud). 2) 'paktte' moet 'pakte' zijn — stam 'pak' eindigt op k (kofschip) → pak + te = pakte, geen dubbele t.",
        "solutionSteps": [
          "Controleer elk werkwoord: is het sterk of zwak?",
          "'rijden' is sterk → hij reed (niet reden)",
          "'pakken' → stam 'pak', k in kofschip → pakte (niet paktte)"
        ]
      }
    },
    {
      "id": "SWW-VT-DUBBEL-007",
      "familyId": "SWW-VT-DUBBEL",
      "module": "SpellingWW",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "verleden_tijd",
      "subSkill": "vt_dubbel_dt",
      "questionType": "fill_in",
      "question": "Vul de verleden tijd in: De brandweerman ... (redden) het kind uit het water.",
      "correctAnswer": "redde",
      "data": {
        "acceptedAnswers": ["redde"],
        "placeholder": "verleden tijd van redden",
        "inputType": "text"
      },
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Dubbele medeklinker in VT", "content": "Stam van 'redden' = 'red'. De d zit NIET in kofschip → -de. Red + de = redde (dubbel d: één van de stam, één van de uitgang).", "icon": "lightbulb" } }
      ],
      "conceptId": "dubbel_fill_in_redde",
      "variantIndex": 7,
      "citoDifficulty": 0.38,
      "citoDiscrimination": 0.71,
      "feedback": {
        "explanationText": "Stam van 'redden' = 'red'. De laatste letter d zit NIET in 't kofschip → uitgang -de. Red + de = redde. De dubbele d ontstaat doordat de stam op d eindigt en de uitgang met d begint.",
        "solutionSteps": [
          "Bepaal de stam: redden → red",
          "Kofschip-check: d zit NIET in kofschip → -de",
          "red + de = redde (dubbel d)"
        ]
      }
    }
  ]
}